import axios from 'axios'

export function createPortalClient(baseURL, adapter) {
  const client = axios.create({ baseURL, withCredentials: true, ...(adapter ? { adapter } : {}) })
  client.interceptors.request.use(async (config) => {
    if (!['get', 'head', 'options'].includes(config.method?.toLowerCase())) {
      const response = await client.get('/csrf/')
      config.headers.set('X-CSRFToken', response.data.csrf_token)
    }
    return config
  })
  return client
}
